module.exports = __webpack_public_path__ + "static/img/banner02.992058b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/banner02.png
// module id = 928
// module chunks = 0